import { Layer } from './layer.model';

export interface Folder {
  uId?: string | null;
  parentUId?: string | null;
  name: string | null;
  sortOrder: number | null;
  folders: Folder[] | null;
  layers: Layer[] | null;
  sectionType?: SectionType | null;
  configuration?: string | null;
  type?: FolderType;
}

export interface FolderState {
  documentCount?: number;
  visibility?: number;
  expanded?: boolean;
  isLoading?: boolean;
  isAnimating?: boolean;
}

export enum FolderType {
  None = 0,
  MappedIn = 99
}

export const FolderVisibility = {
  notSet: 0,
  visible: 1,
  partial: 2,
  hidden: 3
};

export enum SectionType {
  None = 0,
  Alerts = 1,
  Assets = 2,
  Places = 3,
  Weather = 4,
  Annotations = 5,
  Incidents = 6,
  Visualizations = 7,
  HorizonLocationIntelRatings = 8
}
